import { FleekError } from './FleekError';

type UserInBlocklistErrorOptions = Record<string, never>;

export class UserInBlocklistError extends FleekError<UserInBlocklistErrorOptions> {
  public name = 'UserInBlocklistError';

  constructor() {
    super({});
  }

  toString = () => 'User is in the blocklist.';
}
